<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4" v-for="item in list">
        <router-link :to="'/' + item.slug">
          <div class="item d-flex flex-row align-items-center">
            <div>
              <img
                :src="'static/icons/' + item.slug + '.svg'"
                :alt="item.title"
              />
            </div>

            <h3>{{ item.title }}</h3>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { title: "Kommunal xidmətlər", slug: "communal" },
        { title: "Əmək haqqından tutulmalar", slug: "salary" },
        { title: "Pensiya kalkulatoru", slug: "pension" },
        { title: "Daşınmaz  əmlak satışı", slug: "realestate" },
        // { title: "Poçt rabitəsi xidmətləri", slug: "post" },
        { title: "Valyuta konvertoru", slug: "currency" },
        { title: "Gömrük kalkulyatoru", slug: "customs" },
        { title: "Dərmanların qiymətləri", slug: "medicine" },
        { title: "Həftəlik hava proqnozu", slug: "weather" },
        // { title: "Onlayn tərcümə servisi", slug: "translate" },
        // { title: "Şəhərlərarası nəqliyyat", slug: "bus" },
        { title: "Məsafə və yanacaq sərfi", slug: "road" },
        { title: "Avtomobillərin texniki baxışı", slug: "inspection" },
        { title: "Viza barəsində məlumat", slug: "visa" },
        // { title: "Mobil cihazın qeydiyyatı", slug: "imei" },
        { title: "Aylıq namaz vaxtları", slug: "prayer" },
        { title: "İP ünvan və provayderlər", slug: "internet" },
        { title: "Qidaların kalori cədvəli", slug: "calories" },
        { title: "İdeal çəki kalkulyatoru", slug: "bodymass" },
      ],
    };
  },
  methods: {
    getPic(index) {
      return "../assets/icons/" + this.list[index].slug + ".svg";
    },
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
  color: #333;
}
a {
  display: block;
  text-decoration: none;
}
.item {
  padding: 2rem 3rem;
  margin: 1rem 0;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.04);
  background: #fff;
  text-align: center;
  color: #333;
  cursor: pointer;
  border-radius: 5px;
}
.item img {
  width: 70px;
  height: 70px;
  margin-right: 1.4rem;
  display: block;
  padding: 0.5rem;
}
.item h3 {
  font-weight: bold;
}
@media only screen and (max-width: 768px) {
  .item {
    padding: 0.5rem 1rem;
    margin: 0.5rem 0;
    min-height: 110px;
    text-align: left;
  }
  .top img {
    width: 150px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/List.vue